export enum SearchType {
  Organization = 'Organization',
  Collection = 'Collection',
  Private = 'Private',
  Category = 'Category',
  Community = 'Community',
  Internal = 'Internal',
  Loft = 'Loft',
}
